import React from 'react';

import { CartContext, CartDispatchContext } from './CartContext';

export function useCart() {
  const context = React.useContext(CartContext);
  if (context === undefined) {
    throw new Error('The useCart hook must be used within a CartProvider.');
  }
  return context;
}

export function useCartDispatch() {
  const context = React.useContext(CartDispatchContext);
  if (context === undefined) {
    throw new Error(
      'The useCartDispatch hook must be used within a CartProvider.'
    );
  }
  return context;
}
